import { Trans, useTranslation } from '@mc/i18n'
import { PEN_5038_V1_MEGA_CONTENT_PICKER_I18N_NAMESPACE } from '../i18n'

export const HeadingTitle = () => {
  const { t } = useTranslation(PEN_5038_V1_MEGA_CONTENT_PICKER_I18N_NAMESPACE)

  return (
    <>
      <div className='d-none d-lg-block'>
        <Trans
          ns={PEN_5038_V1_MEGA_CONTENT_PICKER_I18N_NAMESPACE}
          i18nKey='trending.headingBreak'
        >
          <br />
        </Trans>
      </div>
      <div className='d-block d-lg-none'>{t('trending.heading')}</div>
    </>
  )
}
